import Data from "../types/Data";

export default function getPeople(data: Data) {
  return data.personIds.map((id) => data.Person[id]);
}
